module.exports = __webpack_public_path__ + "media/images/syftet_logo-5248d5952f689c66791d3f7840c79601.jpg";